// @ts-nocheck
import { populate } from 'populate';
import type { Container, Sprite } from 'pixi.js';

const raw = {
  width: 664,
  height: 667,
  x: 0,
  y: 0,
  list: [
    {
      id: 'fab7a3bd-cd80-4d5e-aef0-365def3347a4',
      type: 'Container',
      runtimeType: null,
      name: 'root',
      className: '',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '',
      data: null,
      stateByName: {}
    },
    {
      id: 'd4e55f8a-3c9c-4eb1-953e-b1509868cd53',
      type: 'Sprite',
      runtimeType: null,
      name: 'tile',
      className: '',
      x: 0,
      y: 0,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'knot_tile_floor',
      parent: 'fab7a3bd-cd80-4d5e-aef0-365def3347a4',
      data: undefined,
      stateByName: {}
    },
    {
      id: '2e999806-1274-4a91-b1b6-642fed259899',
      type: 'Container',
      runtimeType: null,
      name: 'rope_layer',
      className: '',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: 'fab7a3bd-cd80-4d5e-aef0-365def3347a4',
      data: undefined,
      stateByName: {}
    },
    {
      id: 'c87f08d0-e577-4a02-a457-4778823fac18',
      type: 'Container',
      runtimeType: null,
      name: 'knot_container',
      className: '',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: 'fab7a3bd-cd80-4d5e-aef0-365def3347a4',
      data: undefined,
      stateByName: {}
    },
    {
      id: '7eda1ecf-2502-467e-b233-e378d3346c9f',
      type: 'Sprite',
      runtimeType: null,
      name: 'loop_01',
      className: '',
      x: 3,
      y: 12,
      anchor: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'knot_loop_01',
      parent: 'c87f08d0-e577-4a02-a457-4778823fac18',
      data: null,
      stateByName: {}
    },
    {
      id: '5d4a1deb-749d-4efd-9d38-9f161ce81a0e',
      type: 'Sprite',
      runtimeType: null,
      name: 'loop_02',
      className: '',
      x: -3,
      y: 12,
      anchor: {
        x: 0,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'knot_loop_02',
      parent: 'c87f08d0-e577-4a02-a457-4778823fac18',
      data: null,
      stateByName: {}
    },
    {
      id: 'ad0cb653-a3ef-4ddd-8abe-5bd0cd95d54e',
      type: 'Sprite',
      runtimeType: null,
      name: 'loop_03',
      className: '',
      x: -5,
      y: -7,
      anchor: {
        x: 0,
        y: 0
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'knot_loop_03',
      parent: 'c87f08d0-e577-4a02-a457-4778823fac18',
      data: null,
      stateByName: {}
    },
    {
      id: '412614be-468c-45b4-a699-b35c2d8b003f',
      type: 'Sprite',
      runtimeType: null,
      name: 'loop_04',
      className: '',
      x: 5,
      y: -8,
      anchor: {
        x: 1,
        y: 0
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'knot_loop_04',
      parent: 'c87f08d0-e577-4a02-a457-4778823fac18',
      data: null,
      stateByName: {}
    },
    {
      id: '80b58ca4-3131-4e5f-be09-9dc64a19bd6e',
      type: 'Sprite',
      runtimeType: null,
      name: 'knot',
      className: '',
      x: 0,
      y: 0,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'knot_top',
      parent: 'c87f08d0-e577-4a02-a457-4778823fac18',
      data: undefined,
      stateByName: {}
    }
  ],
  version: '1.0.0',
  stateNames: [],
  animations: []
} as const;

export class KnotBlockerLayout {
  static raw = raw;
  root: Container;
  tile: Sprite;
  rope_layer: Container;
  knot_container: Container;
  loop_01: Sprite;
  loop_02: Sprite;
  loop_03: Sprite;
  loop_04: Sprite;
  knot: Sprite;

  mInternalTypes: {
    Raw: typeof raw;
    StateName: never;
    ModelByName: {
      root: typeof raw['list'][0];
      tile: typeof raw['list'][1];
      rope_layer: typeof raw['list'][2];
      knot_container: typeof raw['list'][3];
      loop_01: typeof raw['list'][4];
      loop_02: typeof raw['list'][5];
      loop_03: typeof raw['list'][6];
      loop_04: typeof raw['list'][7];
      knot: typeof raw['list'][8];
    };
  };

  constructor() {
    populate(this, raw);
  }
}
